import { FunctionsHttpError } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';
import { mensagemAmigavel, MENSAGEM_ERRO_TECNICO } from '@/lib/mensagemAmigavel';

export const CHIPS_SUGESTOES = [
  'Como está o evento hoje?',
  'Quem ainda não pagou?',
  'Quantos inscritos por grupo?',
  'Ideias de divulgação',
  'Relatório da semana',
];

// Perguntas prontas do agente de bolso (aparecem acima do campo de digitar).
export const CHIPS_AGENTE: { rotulo: string; texto: string }[] = [
  { rotulo: 'Como estão as vendas?', texto: 'Como estão as vendas?' },
  {
    rotulo: 'O que faço para vender mais hoje?',
    texto: 'O que faço para vender mais hoje?',
  },
  { rotulo: 'Quem ainda não pagou?', texto: 'Quem ainda não pagou?' },
  {
    rotulo: 'Resumo para o WhatsApp da direção',
    texto: 'Resumo para o WhatsApp da direção',
  },
  {
    rotulo: 'Definir a meta',
    texto: 'Quero definir a meta do evento: quantas pessoas e quanto precisamos arrecadar',
  },
];

const DIAS_DA_SEMANA = [
  'domingo',
  'segunda-feira',
  'terça-feira',
  'quarta-feira',
  'quinta-feira',
  'sexta-feira',
  'sábado',
];

// "quarta-feira, 21/10" a partir do dia que a função devolve (AAAA-MM-DD).
export function rotuloDoDia(dia: string): string {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(dia || '');
  if (!partes) return '';
  const d = new Date(Number(partes[1]), Number(partes[2]) - 1, Number(partes[3]));
  if (Number.isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${DIAS_DA_SEMANA[d.getDay()]}, ${dd}/${mm}`;
}

// "22:14" hoje, "ontem 22:14" ontem, "14/10 22:14" antes disso.
export function formatarHoraMensagem(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const hora = `${hh}:${mm}`;

  const agora = new Date();
  const inicioHoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate()).getTime();
  const inicioDia = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const umDia = 24 * 60 * 60 * 1000;

  if (inicioDia === inicioHoje) return hora;
  if (inicioHoje - inicioDia === umDia) return `ontem ${hora}`;
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  return `${dia}/${mes} ${hora}`;
}

export class ErroAssistente extends Error {
  limite: boolean;

  constructor(mensagem: string, limite = false) {
    super(mensagem);
    this.limite = limite;
  }
}

// Fala com a Edge Function "assistente". Em erro, lê { erro, uso? } do corpo
// (quando é um FunctionsHttpError) e devolve uma frase amigável, nunca técnica.
export async function chamarAssistente<T>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('assistente', { body });
  if (!error) return data as T;

  let texto = '';
  let limite = false;
  if (error instanceof FunctionsHttpError) {
    limite = error.context?.status === 429;
    try {
      const corpo = await error.context.json();
      if (corpo && typeof corpo.erro === 'string') texto = corpo.erro;
    } catch {
      /* corpo sem JSON: cai na mensagem padrão */
    }
  }
  throw new ErroAssistente(
    mensagemAmigavel(texto || error, MENSAGEM_ERRO_TECNICO),
    limite,
  );
}